import store from '@/store/index';
import { errorLogout } from '@/utils/errorUtil';
import router from '@/routes/index';
import routerNames from '@/const/routerConstants';

export function setInterceptors(instance) {
  // * Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      const isAthenticated = store.getters.IS_AUTHENTICATED;

      const tokenObj = !isAthenticated
        ? store.getters.GET_TOKEN_OBJ
        : store.state;

      // 로컬 - 항상 header token
      // 운영 - 쿠키 없을때만
      if (
        process.env.NODE_ENV === 'development' ||
        (process.env.NODE_ENV === 'production' && !isAthenticated)
      ) {
        config.headers.authToken = tokenObj.authToken;
        config.headers.userKey = tokenObj.userKey;
        config.headers.sessionToken = tokenObj.sessionToken;
        let userData = encodeURIComponent(JSON.stringify(tokenObj.userData));
        config.headers.userData = userData;
      }

      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  // * Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      if (response.data.errorCode != null) {
        // 스피너 OFF
        store.commit('SPINNER/OFF_COMMON_SPINNER');
        store.commit('SPINNER/OFF_APP_SPINNER');

        // 에러화면으로 이동
        router.push({
          name: routerNames.Error,
          params: {
            status: response.data.errorCode,
            message: response.data.errorMessage,
          },
        });
      }

      return response;
    },

    // ** 응답이 200이 아닐 경우
    function (error) {
      // 스피너 OFF
      store.commit('SPINNER/OFF_COMMON_SPINNER');
      store.commit('SPINNER/OFF_APP_SPINNER');

      // (25.4.17 추가) 앱캐시가 강제로 삭제되어 인증 정보가 없는 경우 로그인으로 이동처리
      if (error.response.status === 905) {
        errorLogout(); // 쿠키제거 + 앱로드아웃호출 + 페이지이동
        return false;
      }

      if (error.response.status >= 500) {
        // 에러화면으로 이동
        router.push({
          name: routerNames.Error,
          params: {
            status: error.response.status,
            message: error.response.data.message,
          },
        });

        return false;
      }

      return Promise.reject(error);
    },
  );
  return instance;
}
